import { template } from "@ember/template-compiler";
import DiagnosticFields from '../not-donor/diagnostic-fields';
import type { TOC } from '@ember/component/template-only';
interface Signature {
    Args: {
        form?: unknown;
    };
}
const MyComponent: TOC<Signature> = template(`
  <div class='field'>
    {{! @glint-expect-error }}
    <@form.Dropdown
      @propertyName='transplantedOrgan'
      @labelName='Type de greffe'
      as |dropdown|
    >
      <dropdown.Item @value='Rein' @key='kidney' />
      <dropdown.Item @value='Rein/Pancréas' @key='kidney-pancreas' />
      <dropdown.Item @value='Rein/Foie' @key='kidney-liver' />
      <dropdown.Item @value='Rein/Poumon' @key='kidney-lung' />
      <dropdown.Item @value='Rein/Poumon/Coeur' @key='kidney-lung-heart' />
      <dropdown.Item @value='Rein/Coeur/Foie' @key='kidney-heart-liver' />
      <dropdown.Item @value='Non renseigné' @key='' />
      {{! @glint-expect-error }}
    </@form.Dropdown>
  </div>

  <div class='two fields' data-test-transplant-date-section>
    <div class='field'>
      {{! @glint-expect-error }}
      <@form.Date
        @labelName='Date de la greffe'
        @propertyName='transplantDate'
      />
    </div>
    <div class='field'>
      <label>
        Rang de la greffe
      </label>
      <div class='four unstackable fields'>
        {{! @glint-expect-error }}
        <@form.BasicRadioGroup @propertyName='transplantRank' as |Group|>
          <Group.FieldRadio @label='1' @value='1' />
          <Group.FieldRadio @label='2' @value='2' />
          <Group.FieldRadio @label='3' @value='3' />
          <Group.FieldRadio @label='4' @value='4' />
          {{! @glint-expect-error }}
        </@form.BasicRadioGroup>
      </div>
    </div>
  </div>

  <div class='field'>
    {{! @glint-expect-error }}
    <@form.AlignedFieldsRadioGroup
      @title='Type de donneur'
      @propertyName='donorType'
      as |Group|
    >
      <Group.FieldRadio @label='Vivant' @value='alive' />
      <Group.FieldRadio @label='Décédé' @value='dead' />
      {{! @glint-expect-error }}
    </@form.AlignedFieldsRadioGroup>
  </div>

  <DiagnosticFields @form={{@form}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default MyComponent;
